interface Dimensions {
  width: number;
  height: number;
}

const setImageSize = (setImageDimensions: (dimensions: Dimensions) => void, imageUrl: string) => {
  const img = new Image();
  img.src = imageUrl;

  img.onload = () => {
    setImageDimensions({
      height: img.height,
      width: img.width,
    });
  };

  img.onerror = (err) => {
    console.error('img error', err);
  };
};

export default setImageSize;
